/*
 * 功能名称: 部门工作基准字典
 * 创 建 人: lichunyang
 * 日    期: 2025年7月25日 11:33
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'
import {Methods} from "@newview/infrastructure";

export class PerformanceRecordApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'performance-record'
  }

  constructor() {
        super();
        this.addHeader("tableName", 'performance_record');
  } 

      
 /**
  * 根据条件获取绩效复核记录
  */
  public getPerformanceRecordList(assessYear, assessMonth, auditStatus, deptId) {
      return this.send({assessYear, assessMonth, auditStatus, deptId}, "getPerformanceRecordList", Methods.GET);
  }

}
